<template>
  <div style="width: 100%;">
      <div>
          <input type="button" class="button" value="downloadFile"  @click="downloadFile()">
          <span  v-if="filename" style=" white-space: nowrap;"> 
            {{ filename }}
          </span>
          
          
      </div>
  </div>

</template>


<script>
export default {
  props: ["filename","filecontent"],

  data() {
    return {
     
    };
  },
  
  created() {
    //console.log('MyUpload.vue')
    //console.log(this.modelValue)
      this.value = this.modelValue;
      if(this.value && this.value.FileId){
        this.fileId=this.value.FileId;
      }
      
  },
  mounted(){
    this.$emit("update:error", this.isError);
  },
  computed: {
    isError() {
      return  this.required && !this.filename ;
    },
  },
  methods: {

    downloadFile(){

      const lineSource=this.filecontent;
      const downloadLink=document.createElement('a')
      const filename=this.filename;

      downloadLink.href=lineSource;
      downloadLink.download=filename;
      downloadLink.click();


      },

   
    },
    
  }



</script>
<style scoped>
.hasError label {
  color:red;
  border-color: red;
  border-width: thin;
}
.hasError div{
  color:red;
  border-color: red;
  border-width: thin;
  border: 1px solid;
  border-radius: 5px;
}
</style>
